import { requests } from '../httpClient';

export const ShoppingBasket = {
    getPaymentIdFromBasketAsync: (shoppingBasketId: string) => requests.post(`Payment/FromBasket`, { ShoppingBasketId: shoppingBasketId })
};
